module.exports = __webpack_public_path__ + "static/media/11_negro.638e5e63.svg";